import React from 'react'
import MarksCoreComponent from './MarksCoreComponent'

function ImageCoreComponent(props) {
  const { imageData, priorityActive } = props
  const {
    ControlID,
    Url,
    AllowDeformed,
    Text,
    Height,
    Width,
    Rotation,
    X,
    Y,
    Mark,
    Priority
  } = imageData
  const image = {
    ControlID: ControlID,
    Url: Url,
    AllowDeformed: AllowDeformed,
    Text: Text,
    Height: Height,
    Width: Width,
    Rotation: Rotation,
    X: X,
    Y: Y,
    Mark: Mark
  }

  return (
    <div
      style={{
        width: image.Width + '%',
        height: image.Height + '%',
        left: image.X,
        top: image.Y,
        position: 'absolute',
        zIndex: priorityActive === Priority ? 3 : 2
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: 'white',
          border: ' 1px solid #B5B5B5',
          borderRadius: '13.0862px',
          padding: '1%'
        }}
      >
        <img
          src={image.Url}
          style={{
            margin: 'auto',
            width: '100%',
            height: '100%'
          }}
        />
        {image.Mark &&
          image.Mark.length > 0 &&
          image.Mark.map((mark, markIndex) => (
            <MarksCoreComponent markerData={mark} x={mark.Y} y={mark.X} />
          ))}
      </div>
    </div>
  )
}

export default ImageCoreComponent
